import moment from "moment";
import { Box, Button, InputAdornment, TextField } from "@mui/material";
import CalendarMonthOutlined from "@mui/icons-material/CalendarMonthOutlined";

const PRESETS = [
  { label: "7D", days: 7 },
  { label: "14D", days: 14 },
  { label: "30D", days: 30 },
];

// From / To date inputs plus quick presets ending today, for the trend dialogs (so the range can be
// changed without closing the dialog). `value` and `onChange` use ["YYYY-MM-DD", "YYYY-MM-DD"].
const DateRangeFields = ({ value, onChange }) => {
  const [from, to] = value;
  const inputSx = {
    width: 160,
    "& .MuiInputBase-root": { cursor: "pointer" },
    "& .MuiInputBase-input": { fontSize: "12px", py: "7px", cursor: "pointer" },
    // The browser's own picker icon is hidden app-wide; the adornment below is the visible one.
    "& input::-webkit-calendar-picker-indicator": { display: "none" },
  };
  // A click anywhere on the field (text or icon) opens the browser's date picker.
  const openPicker = (e) => {
    const input = e.currentTarget.querySelector("input");
    try {
      input?.showPicker?.();
    } catch {
      input?.focus();
    }
  };
  const calendarAdornment = {
    endAdornment: (
      <InputAdornment position="end">
        <CalendarMonthOutlined sx={{ fontSize: 18, color: "#6759FF" }} />
      </InputAdornment>
    ),
  };
  const applyPreset = (days) =>
    onChange([moment().subtract(days - 1, "days").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <TextField
        type="date"
        size="small"
        label="From"
        value={from}
        inputProps={{ max: to }}
        InputLabelProps={{ shrink: true }}
        InputProps={calendarAdornment}
        onClick={openPicker}
        onChange={(e) => e.target.value && onChange([e.target.value, to])}
        sx={inputSx}
      />
      <TextField
        type="date"
        size="small"
        label="To"
        value={to}
        inputProps={{ min: from }}
        InputLabelProps={{ shrink: true }}
        InputProps={calendarAdornment}
        onClick={openPicker}
        onChange={(e) => e.target.value && onChange([from, e.target.value])}
        sx={inputSx}
      />
      {PRESETS.map((p) => (
        <Button
          key={p.label}
          size="small"
          variant="outlined"
          onClick={() => applyPreset(p.days)}
          sx={{ minWidth: 0, px: 1, fontSize: "11px", textTransform: "none", borderColor: "grey.400", color: "#333333" }}
        >
          {p.label}
        </Button>
      ))}
    </Box>
  );
};

export default DateRangeFields;
